/**
 *  To create a pro account, the main user cannot already be the administrator 
 *  of an existing group. Each email must be on separate domain. (with some
 *  caviates. See group_helper.php->checkStarterEmailsValid)
 */

 class ProGroupValidator {

  constructor(options) {

    this.isGroupAdmin = options.isGroupAdmin || false;
    this.addressInputs = options.addressInputs || [];
    this.submitButton = options.submitButton;

    _.each(this.addressInputs, (input)=>{
      input.addEventListener('keyup', e=>this.onKeyUp(e) );
      input.addEventListener('blur', e=>this.onBlur(e) );
    }, this);

  }

  // Event handlers
  onKeyUp(event) {
    this.clearOldMessage();
  }

  onBlur(event) {
    this.validate();
  }

  //
  validate() {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/group/pro_group_validator_ws.php');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.responseType = 'json';
    xhr.onload = () => {
      if( xhr.response.success == false ) {
        this.clearOldMessage();
        this.messageId = FlashMessage.show(xhr.response.errorMsg);
      }
      if( this.submitButton && this.isGroupAdmin == false ) {
        this.submitButton.disabled = (xhr.response.success == false);
      }
    };
    xhr.send(JSON.stringify({
      emails: this.addresses()
    }));
  }

  // helpers
  addresses() {
    return _.map(this.addressInputs, (a)=>a.value)
  }

  clearOldMessage() {
    if( this.submitButton && this.isGroupAdmin == false ) {
      this.submitButton.disabled = false;
    }
    if( this.messageId ) {
      FlashMessage.hide( this.messageId );
      this.messageId = null;
    }
  }

 }
